import { Link, useLocation } from 'react-router-dom';
import {
  // MusicalNoteIcon,
  KeyIcon,
  CreditCardIcon,
  UserIcon,
  DocumentTextIcon,
} from '@heroicons/react/24/outline';
import { useAuth } from '@clerk/clerk-react';
import { cn } from '@/utils';

const navigation = [
  // { name: '概览', href: '/', icon: HomeIcon, public: true },
	{ name: '积分管理', href: '/credits', icon: CreditCardIcon, public: false },
  // { name: '生成音乐', href: '/generate', icon: MusicalNoteIcon, public: false },
  { name: 'API密钥', href: '/api-keys', icon: KeyIcon, public: false },
  { name: 'API文档', href: '/api-docs', icon: DocumentTextIcon, public: true },
  { name: '个人资料', href: '/profile', icon: UserIcon, public: false },
];

export const Sidebar = () => {
  const location = useLocation();
  const { isSignedIn } = useAuth();

  const filteredNavigation = navigation.filter(
    (item) => item.public || isSignedIn
  );

  return (
    <div className="hidden md:flex md:w-64 md:flex-col fixed left-0 top-16 bottom-0 z-40">
      <div className="flex flex-col flex-grow pt-5 bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700 overflow-y-auto h-full">
        <div className="flex flex-col flex-grow">
          <nav className="flex-1 px-2 pb-4 space-y-1">
            {filteredNavigation.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    isActive
                      ? 'bg-purple-50 dark:bg-purple-900/20 border-r-2 border-purple-500 text-purple-700 dark:text-purple-300'
                      : 'text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 hover:text-gray-900 dark:hover:text-white',
                    'group flex items-center px-2 py-2 text-sm font-medium rounded-md transition-colors'
                  )}
                >
                  <item.icon
                    className={cn(
                      isActive
                        ? 'text-purple-500'
                        : 'text-gray-400 group-hover:text-gray-500 dark:group-hover:text-gray-300',
                      'mr-3 flex-shrink-0 h-6 w-6 transition-colors'
                    )}
                  />
                  {item.name}
                </Link>
              );
            })}
          </nav>
        </div>

        {/* 底部信息 */}
        <div className="flex-shrink-0 p-4 border-t border-gray-200 dark:border-gray-700">
          <div className="text-xs text-gray-500 dark:text-gray-400">
            <p>© 2025 Music API</p>
          </div>
        </div>
      </div>
    </div>
  );
};
